import {Button, Text} from "@mantine/core";

interface LoadMoreItemsProps {
    loading: boolean;
    onClick: () => void;
}

export default function LoadMoreItems({loading, onClick}: LoadMoreItemsProps) {
    return (
        <Button loading={loading} onClick={onClick}>
            <Text>Load More Items</Text>
        </Button>
    )
}
